const FeaturesSection = () => {
  const services = [
    {
      icon: 'ri-bone-line',
      title: '整形外科',
      description: '骨折、捻挫、腰痛、肩こりなど、運動器の疾患全般に対応いたします。',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'リハビリテーション科',
      description: '理学療法士による専門的なリハビリテーションを提供しています。',
    },
    {
      icon: 'ri-football-line',
      title: 'スポーツ整形外科',
      description: 'スポーツ障害の診断・治療から競技復帰までサポートします。',
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-amber-50/30 to-white px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-gray-500 text-xs font-normal tracking-[0.2em] uppercase">MEDICAL SERVICES</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mt-4 leading-tight">
            診療案内
          </h2>
          <p className="text-gray-600 text-lg mt-6 max-w-2xl mx-auto">
            患者様一人ひとりに寄り添った丁寧な診療を心がけています
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-10 lg:p-12 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-[#007bbb]`} style={{ strokeWidth: 2 }}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href="/about"
            className="inline-flex items-center bg-[#007bbb] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#006399] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            詳しくはこちら
            <i className="ri-arrow-right-line ml-3 text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
